import * as React from "react";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import IconTextButton from "../../../../repertoire/components/iconTextButton/IconTextButton";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { createCopyOfTableContents } from "../../../../repertoire/services/TableFunctions";
import {
    REMOVE_ACTION,
    DEPENDENT_ROW_ACTION,
    USAGE_MATCH_MAKE_DEFINITE,
    IP_LICENSING_REPRESENTATION_KEY,
    USAGE_MATCHING_WORKS_SECTION_KEY,
    USAGE_PRODUCT_DETAILS_ROWS_SECTION_KEY,
    USAGE_LICENSE_MATCHING,
    USAGE_MATCHING_PRODUCTS_SECTION_KEY,
    DATE_FIELD,
    USAGE_MATCHSTATUS_DEFINITE_MATCH,
    USAGE_MATCHSTATUS_DEFINITE_MATCH_WITHOUT_HISTORY,
    USAGE_MATCHSTATUS_POTENTIAL_MATCH,
    USAGE_MATCHSOURCE_TEXT_MATCH_FORMATTED,
    USAGE_MATCHSOURCE_NUMBER_MATCH_FORMATTED,
    DEFINITE_MATCH,
    POTENTIAL_MATCH,
    USAGE_MATCHSOURCE_MANUAL_MATCH,
	LICENSE_FEE_KEY
} from "../../../Consts";
import DateDisplay from "../../dateDisplay/DateDisplay";
import SaveButtonDropdown from "../../saveButtonDropdown/SaveButtonDropdown";


export interface IDataGridTableRowProps {
    tableContentsItem: any;
    index: number;
    isExpandable: boolean;
    dataGridTableData: IRepertoireComponentDataItem;
    componentInstance: string;
    changeData?: (value: any, name: IRepertoireStateKeys, objectKey?: string, ipRepresentationsIdsToRemove?: number[]) => void;
    stateKey: IRepertoireStateKeys;
    tableContents: any;
    dependentRowAction?: (value: any, event?: React.MouseEvent) => void;
    clearAllRowsButThis?: (value: any, actionType?:string) => void;
    updateIpRepresentationsIdsToRemove?: (tableContentItem: any) => number[];
    openWorkFlow?: boolean;
    onRowClick: () => void;
    focusedRowNumber: number;
    isExpandedUsageMatchingSection?:boolean;
}

const DataGridTableRow: React.FC<IDataGridTableRowProps> = ({
        changeData,
        stateKey,
        tableContents,
        updateIpRepresentationsIdsToRemove,
        isExpandedUsageMatchingSection,
        clearAllRowsButThis,
        dependentRowAction,
        isExpandable,
        tableContentsItem,
        dataGridTableData,
        componentInstance,
        openWorkFlow,
        index,
        onRowClick,
        focusedRowNumber,
}) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [isExpandedUsageMatchingFlag, setIsExpandedUsageMatchingFlag] = React.useState(false);
    const initialHistory = tableContents[0]?.['createMatchHistory'];
    const [localCreateMatchHistory, setLocalCreateMatchHistory] = React.useState(
        initialHistory === undefined || initialHistory === null ? true : initialHistory
    );

    // Update localCreateMatchHistory from backend response after save
    React.useEffect(() => {
        const value = tableContents[0]?.['createMatchHistory'];
        if (value !== undefined) {
            setLocalCreateMatchHistory(
                value === null ? true : value
            );
        }
    }, [tableContents[0]?.['createMatchHistory']]);

    
    React.useEffect(() => {
        setIsExpandedUsageMatchingFlag(isExpandedUsageMatchingSection);
    }, [isExpandedUsageMatchingSection]);


   const onExpandClicked = () => {
       setIsExpanded(!isExpanded);
       setIsExpandedUsageMatchingFlag(!isExpandedUsageMatchingFlag);
   }

    const renderLineBreak = (array: string[]) => {
        return (
            <div>
                {array.map((item, index) => (
                    <div key={index}>
                        {item}
                        {index + 1 !== array.length ? <span>,</span> : null}
                    </div>
                ))}
            </div>
        );
    }

    const  onClickRemove = (tableContentItem: any) => {
        const tableContentsCopy = createCopyOfTableContents(tableContents);

        if (tableContentsCopy.indexOf(tableContentItem) > -1) {
            tableContentsCopy.splice(tableContentsCopy.indexOf(tableContentItem), 1);
        }
        let ipRepresIdsToRemove = []
        if (updateIpRepresentationsIdsToRemove) {
            ipRepresIdsToRemove = updateIpRepresentationsIdsToRemove(tableContentItem);
        }
        changeData(tableContentsCopy, stateKey, null, ipRepresIdsToRemove);
    };

    const onLicenseFeeChange = (value: string) => {
        const tableContentsCopy = createCopyOfTableContents(tableContents);
        tableContentsCopy[index] = {
            ...tableContentsCopy[index],
            [LICENSE_FEE_KEY]: value === "" ? null : Number(value),
        };

        changeData(tableContentsCopy, stateKey, LICENSE_FEE_KEY);
    };

    const renderRowColumns = () => {
        const rowColumns: JSX.Element[] = [];

        if (isExpandable) {
            rowColumns.push(
                <td className="td">
                    <i
                        title="Expand row"
                        className={["icon ms-Icon ms-Icon--Chevron", (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY || USAGE_MATCHING_PRODUCTS_SECTION_KEY ? isExpandedUsageMatchingFlag : isExpanded) ? "Down" : "Right"].join("")}
                        onClick={() => onExpandClicked()}
                    />
                </td>
            );
        }

        let filteredFields = dataGridTableData.fields.filter(
            (field: IRepertoireField) =>
                field.componentInstance === componentInstance
        );

        filteredFields.map((field, x: number) => {
            const value = tableContentsItem[field.name];
            
            const isPotentialMatch = tableContentsItem['status'] === USAGE_MATCHSTATUS_POTENTIAL_MATCH;
            const isDefiniteManualMatch = (tableContentsItem['status'] === USAGE_MATCHSTATUS_DEFINITE_MATCH && tableContentsItem['source'] === USAGE_MATCHSOURCE_MANUAL_MATCH)
            const isMultiDefiniteMatch = tableContents?.length > 1 && tableContentsItem['status'] === USAGE_MATCHSTATUS_DEFINITE_MATCH
            const makeDefiniteDisabled = !!openWorkFlow || (!isPotentialMatch && !isDefiniteManualMatch && !isMultiDefiniteMatch);
            
            if (field.fieldType === REMOVE_ACTION) {
                rowColumns.push(
                    <td className="td" key={REMOVE_ACTION}>
                        <div className={["tableCell", (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY || USAGE_MATCHING_PRODUCTS_SECTION_KEY ? isExpandedUsageMatchingFlag : isExpanded) ? "rowExpanded" : "rowUnexpanded"].join(" ")}>
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--Delete"}
                                text={""}
                                id={"Remove"}
                                onClick={() => onClickRemove(tableContentsItem)}
                                disabled={openWorkFlow}
                            />
                        </div>
                    </td>
                );
            }
            if (USAGE_PRODUCT_DETAILS_ROWS_SECTION_KEY === componentInstance && field.name === "") {
                rowColumns.push(
                    <td className="td" key={DEPENDENT_ROW_ACTION}>
                        <div className="tableCell">
                            <DateDisplay value={value} />
                        </div>
                    </td>
                );
                return;
            }
            if (field.fieldType === DATE_FIELD) {
                rowColumns.push(
                    <td className="td" key={DATE_FIELD}>
                        <div className="tableCell">
                            <DateDisplay value={value} />
                        </div>
                    </td>
                );
                return;

            }
            if (field.fieldType === DEPENDENT_ROW_ACTION) {
                if (componentInstance === IP_LICENSING_REPRESENTATION_KEY) {
                    rowColumns.push(
                        <td className="td" key={DEPENDENT_ROW_ACTION}>
                            <div className="tableCell">
                                <IconTextButton
                                    icon={"icon ms-Icon ms-Icon--OpenInNewTab"}
                                    text={tableContentsItem.workGroupDescription}
                                    onClick={(event) => dependentRowAction(tableContentsItem, event)}
                                    disabled={!tableContentsItem.workGroupDescription}
                                />
                            </div>
                        </td>
                    );
                }
                else {
                    rowColumns.push(
                        <td className="td" key={DEPENDENT_ROW_ACTION}>
                            <div className="tableCell">
                                <IconTextButton
                                    icon={"icon ms-Icon ms-Icon--OpenInNewTab"}
                                    text={field.data}
                                    onClick={(event) => dependentRowAction(tableContentsItem, event)}
                                    disabled={false}
                                />
                            </div>
                        </td>
                    );
                }
            }
           else if (field.name === USAGE_MATCH_MAKE_DEFINITE && tableContents.length > 1) {
                const isWithHistory = localCreateMatchHistory === undefined || localCreateMatchHistory === null ? true : localCreateMatchHistory;
                const matchHistoryLabel = isWithHistory ? "With History" : "Without History";
                rowColumns.push(
                    <td className="td" key={"makeDefinite"}>
                        <div className={["tableCell", (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY || USAGE_MATCHING_PRODUCTS_SECTION_KEY ? isExpandedUsageMatchingFlag : isExpanded) ? "rowExpanded" : ""].join(" ")}>
                        <SaveButtonDropdown
                                mainLabel={matchHistoryLabel}
                                mainOnClick={() => {
                                const actionType = isWithHistory
                                    ? USAGE_MATCHSTATUS_DEFINITE_MATCH
                                    : USAGE_MATCHSTATUS_DEFINITE_MATCH_WITHOUT_HISTORY;
                                clearAllRowsButThis(tableContentsItem, actionType);
                                }}
                                    disabled={makeDefiniteDisabled}
                                options={
                                    isWithHistory
                                        ? [
                                            {
                                                label: "Without History",
                                                onClick: () => {
                                                    setLocalCreateMatchHistory(false);
                                                    clearAllRowsButThis(
                                                        tableContentsItem,
                                                        USAGE_MATCHSTATUS_DEFINITE_MATCH_WITHOUT_HISTORY
                                                    );
                                                },
                                                disabled: openWorkFlow,
                                            },
                                        ]
                                        : [
                                            {
                                                label: "With History",
                                                onClick: () => {
                                                    setLocalCreateMatchHistory(true);
                                                    clearAllRowsButThis(
                                                        tableContentsItem,
                                                        USAGE_MATCHSTATUS_DEFINITE_MATCH
                                                    );
                                                },
                                                disabled: openWorkFlow,
                                            },
                                        ]
                                }
                            />
                    </div>
                    </td>)
            }
            else if (field.name === USAGE_MATCH_MAKE_DEFINITE && (componentInstance === USAGE_LICENSE_MATCHING || componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY || componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY)) {
                const isWithHistory = localCreateMatchHistory === undefined ||localCreateMatchHistory === null ? true : localCreateMatchHistory;
                const matchHistoryLabel = isWithHistory ? "With History" : "Without History";
                rowColumns.push(
                    <td className="td" key={"makeDefinite"}>
                        <div className={"tableCell"}>
                            {(tableContentsItem['status'] === USAGE_MATCHSTATUS_POTENTIAL_MATCH || tableContentsItem['status'] === USAGE_MATCHSTATUS_DEFINITE_MATCH || tableContentsItem['status'] === DEFINITE_MATCH ||
                                tableContentsItem['status'] === POTENTIAL_MATCH) && (
                                <SaveButtonDropdown
                                    mainLabel={matchHistoryLabel}
                                    mainOnClick={() => {
                                    const actionType = isWithHistory
                                        ? USAGE_MATCHSTATUS_DEFINITE_MATCH
                                        : USAGE_MATCHSTATUS_DEFINITE_MATCH_WITHOUT_HISTORY;
                                    clearAllRowsButThis(tableContentsItem, actionType);
                                    }}
                                    disabled={makeDefiniteDisabled}
                                    options={
                                        isWithHistory
                                            ? [
                                                {
                                                    label: "Without History",
                                                    onClick: () => {
                                                        setLocalCreateMatchHistory(false);
                                                        clearAllRowsButThis(
                                                            tableContentsItem,
                                                            USAGE_MATCHSTATUS_DEFINITE_MATCH_WITHOUT_HISTORY
                                                        );
                                                    },
                                                    disabled: openWorkFlow,
                                                },
                                            ]
                                            : [
                                                {
                                                    label: "With History",
                                                    onClick: () => {
                                                        setLocalCreateMatchHistory(true);
                                                        clearAllRowsButThis(
                                                            tableContentsItem,
                                                            USAGE_MATCHSTATUS_DEFINITE_MATCH
                                                        );
                                                    },
                                                    disabled: openWorkFlow,
                                                },
                                            ]
                                    }
                                />
                            )}
                        </div>
                    </td>)
            }
            else if (field.name === 'title' && (USAGE_MATCHING_WORKS_SECTION_KEY === componentInstance || USAGE_MATCHING_PRODUCTS_SECTION_KEY  === componentInstance)) { 
                rowColumns.push(
                    <td key={field.name} className="td">
                        <div className={["tableCell", (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY || USAGE_MATCHING_PRODUCTS_SECTION_KEY ? isExpandedUsageMatchingFlag : isExpanded) ? "rowExpanded" : "rowUnexpanded"].join(" ")} >
                            <a                              
                                onClick={(event) => {
                                   event.preventDefault(); 
                                   dependentRowAction(tableContentsItem, event);
                                }}
                            >
                                {Array.isArray(value) ? renderLineBreak(value) : value}                               
                            </a>
                        </div>
                    </td>
                );
            }
            else if (field.name === LICENSE_FEE_KEY && componentInstance === USAGE_LICENSE_MATCHING) {
				var rowColumn = (
					!field.disabled ?
					<td key={field.name} className="td">
                        <div className="tableCell">
                            <input
                                type="number"
                                min={0}
                                value={value ?? ""}
                                onChange={(event) => onLicenseFeeChange(event.target.value)}
                                disabled={openWorkFlow}
                            />
                        </div>
                    </td>
					:
					<td key={field.name} className="td">
                        <div className="tableCell rowUnexpanded">{value}</div>
                    </td>
					
				)
                rowColumns.push(rowColumn);
            }
            else {
                rowColumns.push(
                    <td key={field.name} className="td">
                        <div className={["tableCell", (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY || USAGE_MATCHING_PRODUCTS_SECTION_KEY ? isExpandedUsageMatchingFlag : isExpanded) ? "rowExpanded" : "rowUnexpanded"].join(" ")}>
                            {Array.isArray(value) ? renderLineBreak(value) : value}
                        </div>
                    </td>

                );
            }
        });
        return rowColumns;
    }

        return (
            <tr className={`tr ${focusedRowNumber === index && 'focusedTableRow'}`} onClick={() => onRowClick()} key={index}>{renderRowColumns()}</tr >
        );
}

export default DataGridTableRow;